import { AxiosResponse } from 'axios';

import BaseApi from './BaseApi';

const ExchangeApi = {
  initExchange(
    token: string,
    dto: {
      agentId?: number;
      tokenCountFrom?: number;
      tokenCountTo?: number;
      tokenNameFrom?: string;
      tokenNameTo?: string;
      isPublic?: boolean;
      expiryDate?: Date;
    }
  ): Promise<AxiosResponse> {
    return BaseApi.post('api/v1/exchange/init', dto, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  signExchange(
    token: string,
    payload: {
      hash: string;
      checksum: string;
      signature: string;
      accountId: number;
      id: number;
      documentType: string;
    }
  ): Promise<AxiosResponse> {
    return BaseApi.post('api/v1/exchange/sign', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getExchanges(
    token: string,
    payload: {
      search?: string;
      accountId: number;
      period?: {
        from?: string;
        to?: string;
        direction?: 'ASC' | 'DESC';
      };
      isPublic?: boolean;
    }
  ): Promise<AxiosResponse> {
    return BaseApi.post('api/v1/exchange/offers/search', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getExchange(token: string, id: number): Promise<AxiosResponse> {
    return BaseApi.get(`api/v1/exchange/offers/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getAgreement(
    token: string,
    payload: {
      id: number;
      accountId: number;
      signed?: boolean;
    }
  ): Promise<AxiosResponse<ArrayBuffer>> {
    const { id, accountId, signed = false } = payload;
    return BaseApi.get(
      `/api/v1/exchange/offers/${id}/agreement?accountId=${accountId}&signed=${signed}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/pdf',
        },
        responseType: 'arraybuffer',
      }
    );
  },

  cryptoSign(
    token: string,
    payload: {
      privateKey: string;
      operationId: number;
    }
  ): Promise<AxiosResponse> {
    return BaseApi.post(`/api/v1/exchange/crypto/sign`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};

export default ExchangeApi;
